import _get from "lodash/get";
import { AnyAction } from "redux";
import { PhoneNumberState } from "../../../../../models/state";
import { fulfilled } from "../../utils";
import * as AT from "../actionTypes";

const initialState = (): PhoneNumberState => ({
    selectedPhoneNumber: "",
    check: {
        isAllowedToProceed: false,
    },
});

const reducer = (state = initialState(), action: AnyAction): PhoneNumberState => {
    switch (action.type) {
        case AT.CHECKOUT_SET_SELECTED_PHONE_NUMBER:
            return {
                ...state,
                selectedPhoneNumber: action.selectedPhoneNumber,
                check: {
                    ...state.check,
                    type: action.customerType,
                    isAllowedToProceed: action.allowedToProceed,
                },
            };
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
            return {
                ...state,
                accountId: _get(action, "payload.phoneNumberData.accountId"),
                check: {
                    type: _get(action, "payload.phoneNumberData.type"),
                    isAllowedToProceed: !!action.payload.allowedToProceed,
                },
            };
        default:
            return state;
    }
};

export default reducer;
